import request from "@/common/request";
import { MotivoCancelamento, Page } from "@/models";

export const findMotivo = async (params?: any, isFiscal?: boolean): Promise<Page<MotivoCancelamento>> =>
	request.get(`/motivosCancelamento/${isFiscal != null ? isFiscal : false}`, {
		params: {
			...params,
		},
	})


export const createMotivo = async (motivo: MotivoCancelamento): Promise<MotivoCancelamento> =>
	request.post(`/motivosCancelamento`, motivo)

export const updateMotivo = async (motivo: MotivoCancelamento): Promise<MotivoCancelamento> =>
	request.put(`/motivosCancelamento/${motivo.id}`, motivo)